var _g, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelenium({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Selenium",
    xmlns: "http://www.w3.org/2000/svg",
    width: 109,
    height: 112,
    viewBox: "0 0 109 112",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(-0.135 0.024)",
    opacity: 0.151
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Icon.BG",
    cx: 54.5,
    cy: 56,
    rx: 54.5,
    ry: 56,
    transform: "translate(0.135 -0.024)",
    fill: "#e2b97a"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_12615",
    "data-name": "Path 12615",
    d: "M634.271,839.24c-4.129,4.1-6.951,10.133-4.954,12.148s8.059-.758,12.188-4.854,4.763-7.963,2.766-9.977-5.871-1.413-10,2.683",
    transform: "translate(-574.313 -774.45)",
    fill: "#e2b97a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12617",
    "data-name": "Path 12617",
    d: "M638.7,809.038c-2.769-.618-5.7,1.978-6.972,7.654s-.387,12.282,2.382,12.9,6.377-4.986,7.644-10.662-.285-9.275-3.054-9.893",
    transform: "translate(-574.313 -774.45)",
    fill: "#e2b97a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12620",
    "data-name": "Path 12620",
    d: "M616.136,820.38a5.2,5.2,0,0,0-2.508.635c-2.921,1.587-4.313,6.05-.842,12.442,2.425,4.463,6.961,9.208,10.592,9.208a3.68,3.68,0,0,0,1.774-.434c4-2.176,1.991-10.326-.629-15.149-2.314-4.259-5.37-6.7-8.387-6.7m7.545,19.141a.622.622,0,0,1-.3.062c-1.773,0-5.521-3.249-7.883-7.6-2.093-3.855-2.256-7.251-.4-8.262a2.127,2.127,0,0,1,1.037-.261c1.408,0,3.64,1.336,5.678,5.089,2.854,5.253,2.921,10.4,1.867,10.969",
    transform: "translate(-574.313 -774.45)",
    fill: "#a88a5c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelenium);
export default __webpack_public_path__ + "static/media/Selenium.89c5009f7b40718b0ce69169793af1ec.svg";
export { ForwardRef as ReactComponent };